import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_OPEN, consent, setConsent } from "@/lib/track";

const BUTTON =
  "h-10 flex-1 rounded-full bg-[#f7f7f7] px-5 text-[13px] font-medium transition-colors hover:bg-black hover:text-white";

// Asks once whether the site may be measured. Both answers weigh the same,
// and "Cookie settings" in the footer opens it again.
export default function Consent() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(consent() === null);
    const show = () => setOpen(true);
    window.addEventListener(CONSENT_OPEN, show);
    return () => window.removeEventListener(CONSENT_OPEN, show);
  }, []);
  if (!open) return null;
  const choose = (allowed) => {
    setConsent(allowed);
    setOpen(false);
  };
  return (
    <section
      aria-label="Cookies"
      data-testid="consent"
      className="fixed inset-x-3 bottom-3 z-[80] rounded-[20px] bg-white p-5 text-black shadow-[0_12px_40px_-12px_rgba(0,0,0,0.3)] ring-1 ring-black/10 animate-in fade-in slide-in-from-bottom-2 duration-500 sm:inset-x-auto sm:bottom-5 sm:left-5 sm:w-[380px] print:hidden"
    >
      <p className="text-[16px] font-medium leading-[1.25] tracking-[-0.015em]">
        May we measure how this site is used?
      </p>
      <p className="mt-2 text-[13px] leading-[1.45] opacity-60">
        If you allow it, we count visits and record sessions, with typed text
        hidden. Nothing is set until you choose.{" "}
        <Link to="/privacy" className="underline underline-offset-2">
          Privacy
        </Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          className={BUTTON}
          data-testid="consent-decline"
          onClick={() => choose(false)}
        >
          Decline
        </button>
        <button
          type="button"
          className={BUTTON}
          data-testid="consent-allow"
          onClick={() => choose(true)}
        >
          Allow
        </button>
      </div>
    </section>
  );
}
